/**
 * Tiny in-progress-récit count pill — mirrors QuestNavBadge (9+ cap, hidden when
 * 0). Uses bg-rum-500 (a shade that EXISTS in tailwind.config — rum-600 is absent
 * and renders transparent; see project memory). Dumb on purpose: count in, pill out.
 */
export function RecitNavBadge({ count }: { count: number }) {
  if (count <= 0) return null
  return (
    <span className="absolute -top-0.5 -right-0.5 min-w-[1rem] h-4 px-1 grid place-items-center rounded-full bg-rum-500 text-[10px] font-bold text-white">
      {count > 9 ? '9+' : count}
    </span>
  )
}
